module.exports = __webpack_public_path__ + "files/b1c3ab49cedc4f5455548b64518b03d0.png";